import { BulkAmountConfig, PriceConfig } from 'app/product-designer-config';

export class Price
{
  private _reducedAmount: number = 0.0;
  private _regularAmount: number = 0.0;
  private _reduction: number = 0.0;

  constructor(p?: BulkAmountConfig|Price|PriceConfig, quantity: number = 1)
  {
    if (p) {
      this._regularAmount = p.regularAmount * quantity;
      this._reducedAmount = p.reducedAmount * quantity;
      this._reduction = this.calculateReduction();
    }
  }

  private calculateReduction(): number
  {
    return this._regularAmount - this.reducedAmount;
  }

  public get reducedAmount(): number
  {
    return this._reducedAmount;
  }

  public get regularAmount(): number
  {
    return this._regularAmount;
  }

  public get reduction(): number
  {
    return this._reduction;
  }

  public add(
      other: BulkAmountConfig|Price|PriceConfig, quantity: number = 1): Price
  {
    this._regularAmount += other.regularAmount * quantity;
    this._reducedAmount += other.reducedAmount * quantity;
    this._reduction = this.calculateReduction();
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/price/price.ts